module.exports = __webpack_public_path__ + "static/media/teachingCV.b7cae279.pdf";